import moment, { Moment } from 'moment';
import { create } from 'zustand';
import { RatingAssumption, TaxDesignation } from '../deal-builder/services/utils/primary-constants.ts';

export type PricingManagementFilterInput = {
  minDate: Moment,
  setMinDate: (minDate: Moment) => void,

  maxDate: Moment,
  setMaxDate: (maxDate: Moment) => void,

  minMaturity: number,
  setMinMaturity: (minMaturity: number) => void,

  maxMaturity: number,
  setMaxMaturity: (maxMaturity: number) => void,

  minRating: RatingAssumption,
  setMinRating: (minRating: RatingAssumption) => void,

  maxRating: RatingAssumption,
  setMaxRating: (minRating: RatingAssumption) => void,

  taxDesignations: TaxDesignation[],
  setTaxDesignations: (taxDesignations: TaxDesignation[]) => void,

  coverBidLimit: number,
  setCoverBidLimit: (coverBidLimit: number) => void,

  updateAll: (filters: PricingManagementFilterInput) => void,
}

const DEFAULT_MIN_DATE = moment().subtract(1, "year");
const DEFAULT_MAX_DATE = moment();
const DEFAULT_MIN_MATURITY = 0;
const DEFAULT_MAX_MATURITY = 30;
const DEFAULT_MIN_RATING = RatingAssumption.BBBMinus;
const DEFAULT_MAX_RATING = RatingAssumption.AAA;
const DEFAULT_TAX_DESIGNATIONS = Object.values(TaxDesignation);
const DEFAULT_COVER_BID_LIMIT = 0.1;

const usePricingManagamentAnalyzerStore = create<PricingManagementFilterInput>((set) => ({
  minDate: DEFAULT_MIN_DATE,
  setMinDate: (minDate: Moment) => set({ minDate }),

  maxDate: DEFAULT_MAX_DATE,
  setMaxDate: (maxDate: Moment) => set({ maxDate }),

  minMaturity: DEFAULT_MIN_MATURITY,
  setMinMaturity: (minMaturity: number) => set({ minMaturity }),

  maxMaturity: DEFAULT_MAX_MATURITY,
  setMaxMaturity: (maxMaturity: number) => set({ maxMaturity }),

  minRating: DEFAULT_MIN_RATING,
  setMinRating: (minRating: RatingAssumption) => set({ minRating }),

  maxRating: DEFAULT_MAX_RATING,
  setMaxRating: (maxRating: RatingAssumption) => set({ maxRating }),

  taxDesignations: DEFAULT_TAX_DESIGNATIONS,
  setTaxDesignations: (taxDesignations: TaxDesignation[]) => set({ taxDesignations }),

  coverBidLimit: DEFAULT_COVER_BID_LIMIT,
  setCoverBidLimit: (coverBidLimit: number) => set({ coverBidLimit }),

  updateAll: (filters: PricingManagementFilterInput) => set(filters),
}));

export default usePricingManagamentAnalyzerStore;
